// Application settings configurable by developers
const appSettings = {
    // API settings - use environment variables with fallbacks
    apiUrl: process.env.REACT_APP_API_URL || 'http://192.168.50.102:9090/v1',
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',

    // Security
    appSecretKey: process.env.REACT_APP_API_SECRET_KEY, 

    // Game settings
    countdownDuration: 3, // Countdown duration in seconds

    // UI settings
    maxGridSize: 9, // Maximum supported grid size
    defaultTheme: process.env.REACT_APP_THEME || 'light',

    // Feature flags
    enableDebugMode: process.env.REACT_APP_DEBUG === 'true' || process.env.NODE_ENV === 'development',
    enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    enableErrorReporting: process.env.REACT_APP_ENABLE_ERROR_REPORTING === 'true',

    // Google ads
    adProviders: {
      google: {
        adTagUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dlinear&env=vp&output=vast&unviewed_position_start=1&correlator='
        }
    }
  };
  
  export default appSettings;
  